import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IPermission } from "@defs/permission";

interface PermissionsState {
  data: IPermission[];
  loading: boolean;
  error: boolean;
}

const initialState: PermissionsState = {
  data: [],
  loading: true,
  error: false,
};

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    reset(state) {
      state.loading = initialState.loading;
      state.data = initialState.data;
      state.error = initialState.error;
    },
  },
  extraReducers: {
    "permissions/list/pending": (state) => {
      state.loading = true;
      state.data = [];
    },
    "permissions/list/fulfilled": (
      state,
      action: PayloadAction<IPermission[]>
    ) => {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const permissionActions = permissionsSlice.actions;

export default permissionsSlice.reducer;
